import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, withTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AlertNotice, Card } from 'shared/components';
import uniqueId from 'lodash/uniqueId';

import './UserAssignments.scss';

class UserAssignments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAssignments: false,
    };

    this.toggleShowAssignments = this.toggleShowAssignments.bind(this);
  }

  toggleShowAssignments() {
    this.setState((prevState) => ({
      showAssignments: !prevState.showAssignments,
    }));
  }

  render() {
    const { assignments, userIsAssigned } = this.props;
    const { showAssignments } = this.state;
    const limit = showAssignments ? assignments.length : 4;

    return (
      <section className="dash-section dash-padding">
        <section className="user-assignments">
          <h4 className="fw-bold">
            {this.props.t('dashboard.assignmentsTitle')}{' '}
            {!!assignments.length && `(${assignments.length})`}
          </h4>

          {assignments.length ? (
            <React.Fragment>
              <div className="card-container">
                {assignments.slice(0, limit).map((event) => (
                  <Card small key={uniqueId()} className="active assignment-card">
                    <EventLink event={event}>
                      <EventDetails event={event} />
                    </EventLink>
                  </Card>
                ))}
                <div className={`${limit === assignments.length ? 'd-none' : ''} hide-desktop`}>
                  {assignments.slice(limit, assignments.length).map((event) => (
                    <Card small key={uniqueId()} className="active assignment-card">
                      <EventLink event={event}>
                        <EventDetails event={event} />
                      </EventLink>
                    </Card>
                  ))}
                </div>
              </div>
              <div className={`${assignments.length < 5 ? 'd-none' : ''} show-desktop mt-3`}>
                <button onClick={this.toggleShowAssignments} className="btn-link fw-bold">
                  <i className="material-icons">{`${showAssignments ? 'remove' : 'add'}`}</i>
                  <span>
                    {this.props.t(
                      showAssignments ? 'dashboard.hideAssignments' : 'dashboard.showAssignments'
                    )}
                  </span>
                </button>
              </div>
            </React.Fragment>
          ) : (
            <AlertNotice
              message={this.props.t(
                userIsAssigned
                  ? 'dashboard.assignmentsEnrolledMessage'
                  : 'dashboard.assignmentsMessage'
              )}
            />
          )}
        </section>
      </section>
    );
  }
}

export default withTranslation()(UserAssignments);
UserAssignments.propTypes = {
  assignments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  userIsAssigned: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

const EventLink = ({ event, children }) => {
  let link = `/test-event/${event.testCenterEventId}`;
  if (event.roomId) {
    link = `${link}/room/${event.roomId}`;
  }
  return (
    <Link href={link} to={link} className="assignment-event-link">
      {children}
    </Link>
  );
};

EventLink.propTypes = {
  event: PropTypes.shape({}).isRequired,
  children: PropTypes.node.isRequired,
};

export const EventDetails = ({ event }) => {
  const { t } = useTranslation();
  return (
    <div className={`assignment-card-content ${!!event.rescheduleDate && 'show-label'}`}>
      {!!event.rescheduleDate && (
        <div className="reschedule-label">{t('common.labels.rescheduled')}</div>
      )}
      <div className="fw-bold text-navy">{event.testName}</div>
      <div className="card-details">{event.program.name}</div>
      <div className="card-details">{event.testCenterName}</div>
      {event.roomName && <div className="card-details">{event.roomName}</div>}
      <p className="assignment-role text-strong text-navy display-bottom">
        {event.role && event.role.name}
      </p>
    </div>
  );
};

EventDetails.propTypes = {
  event: PropTypes.shape({}).isRequired,
};
